export const state = {
    users: [],
    posts: [],
    isLoading: false,
    page: 1,
    callback: null,
    postKeyword: "",
    stack: null
  }